export const REFERRAL_CODE_QUERY_PARAM = 'referral_code';
